import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  fechaADDMMYYYY(valor: string) {
    const fecha = (new Date(valor)).toISOString().slice(0, 10);
    return fecha.slice(8, 10) + '/' + fecha.slice(5, 7) + '/' + fecha.slice(0, 4);
  }
}
